import { createFilterGroup, createFilterLine, type FilterGroupItem } from '@civilgrid/ui/utils';

export function getAllUtilityTypes(): FilterGroupItem {
  return createFilterGroup(
    [
      createFilterLine('agency.type', 'eq', 'Storm'),
      createFilterLine('agency.type', 'eq', 'Sewer'),
      createFilterLine('agency.type', 'eq', 'Water'),
      createFilterLine('agency.type', 'eq', 'Electric'),
      createFilterLine('agency.type', 'eq', 'Gas'),
    ],
    {
      operator: 'or',
    },
  );
}

export function getStorm(): FilterGroupItem {
  return createFilterGroup([createFilterLine('agency.type', 'eq', 'Storm')]);
}

export function getSewer(): FilterGroupItem {
  return createFilterGroup([createFilterLine('agency.type', 'eq', 'Sewer')]);
}

export function getWater(): FilterGroupItem {
  return createFilterGroup([createFilterLine('agency.type', 'eq', 'Water')]);
}

export function getElectric(): FilterGroupItem {
  return createFilterGroup([createFilterLine('agency.type', 'eq', 'Electric')]);
}

export function getGas(): FilterGroupItem {
  return createFilterGroup([createFilterLine('agency.type', 'eq', 'Gas')]);
}
